module.exports = __webpack_public_path__ + "static/media/Inter-ExtraBold.3f65bd10.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-ExtraBold.woff2
// module id = 684
// module chunks = 21